import type { FooterTemplate } from '@iheartjane/data-access';
import { Card, Flex, Link, Typography } from '@iheartjane/reefer';
import { Controller, useFormContext } from 'react-hook-form';

import { ColorPicker } from '@jane/business-admin/components/premium/ColorPicker';

import styles from './Footer.module.css';

interface ColorsSectionProps {
  defaultColors?: {
    background: string;
    primary: string;
  };
}

export const ColorsSection = ({ defaultColors }: ColorsSectionProps) => {
  const { control, setValue } = useFormContext<FooterTemplate>();

  const handleRestoreDefault = () => {
    if (defaultColors) {
      setValue('colors.primary', defaultColors.primary, { shouldDirty: true });
      setValue('colors.background', defaultColors.background, {
        shouldDirty: true,
      });
    }
  };

  return (
    <Card
      border="grays-ultralight"
      className={styles['sectionCard']}
      id="colors"
    >
      <Flex flexDirection="column" gap={16} mb={8} p={40}>
        <Flex justifyContent="space-between" alignItems="center">
          <Typography variant="h2-semibold">Colors</Typography>
          <Link onClick={handleRestoreDefault}>Restore default</Link>
        </Flex>
        <Typography>
          Your menu's colors are used by default, edit these here if you want
          your footer colors to be different.
        </Typography>
        <Flex>
          <Controller
            name="colors.primary"
            control={control}
            render={({ field }) => (
              <ColorPicker
                label="Primary (button)"
                value={field.value ?? ''}
                onChange={field.onChange}
                shouldStretch={true}
              />
            )}
          />
          <Controller
            name="colors.background"
            control={control}
            render={({ field }) => (
              <ColorPicker
                label="Background"
                value={field.value ?? ''}
                onChange={field.onChange}
                shouldStretch={true}
              />
            )}
          />
        </Flex>
      </Flex>
    </Card>
  );
};
